<svg
  xmlns="http://www.w3.org/2000/svg"
  width="48"
  height="48"
  viewBox="0 0 64 64"
  class="mx-auto sm:mx-0"
  ><defs
    ><linearGradient id="a" x1="11.661%" x2="88.339%" y1="17.891%" y2="82.109%"
      ><stop offset="0%" stop-color="#FFF" /><stop
        offset="10%"
        stop-color="#E7E8E6"
      /><stop offset="10%" stop-color="#CDD0D0" /><stop
        offset="20%"
        stop-color="#B5BBBD"
      /><stop offset="20%" stop-color="#A5ACAF" /><stop
        offset="30%"
        stop-color="#9BA3A7"
      /><stop offset="30%" stop-color="#98A0A4" /><stop
        offset="40%"
        stop-color="#828A8F"
      /><stop offset="50%" stop-color="#667075" /><stop
        offset="60%"
        stop-color="#535C63"
      /><stop offset="70%" stop-color="#475158" /><stop
        offset="80%"
        stop-color="#434D54"
      /><stop offset="100%" stop-color="#475157" /></linearGradient
    ><linearGradient id="b" x1="11.735%" x2="88.265%" y1="17.857%" y2="82.143%"
      ><stop offset="0%" stop-color="#0B1F2A" /><stop
        offset="20%"
        stop-color="#333F47"
      /><stop offset="50%" stop-color="#777F84" /><stop
        offset="50%"
        stop-color="#81898D"
      /><stop offset="70%" stop-color="#B3B8B8" /><stop
        offset="80%"
        stop-color="#D2D5D3"
      /><stop offset="80%" stop-color="#DEE0DD" /><stop
        offset="100%"
        stop-color="#FBFBFB"
      /></linearGradient
    ><linearGradient id="c" x1="67.145%" x2="32.926%" y1="97.042%" y2="2.98%"
      ><stop offset="0%" stop-color="#E1E3E1" /><stop
        offset="10%"
        stop-color="#C1C5C4"
      /><stop offset="30%" stop-color="#9BA1A2" /><stop
        offset="50%"
        stop-color="#7D8487"
      /><stop offset="70%" stop-color="#687074" stop-opacity="0" /><stop
        offset="80%"
        stop-color="#5B6469"
        stop-opacity="0"
      /><stop
        offset="100%"
        stop-color="#576065"
        stop-opacity="0"
      /></linearGradient
    ><linearGradient id="d" x1="25%" x2="75%" y1="6.703%" y2="93.297%"
      ><stop offset="0%" stop-color="#E1E3E1" /><stop
        offset="10%"
        stop-color="#C1C5C4"
      /><stop offset="30%" stop-color="#9BA1A2" /><stop
        offset="50%"
        stop-color="#7D8487"
      /><stop offset="70%" stop-color="#687074" stop-opacity="0" /><stop
        offset="80%"
        stop-color="#5B6469"
        stop-opacity="0"
      /><stop
        offset="100%"
        stop-color="#576065"
        stop-opacity="0"
      /></linearGradient
    ><linearGradient id="e" x1="50.41%" x2="43.443%" y1="49.319%" y2="55.931%"
      ><stop offset="0%" stop-color="#27343C" /><stop
        offset="100%"
        stop-color="#00111E"
        stop-opacity="0"
      /></linearGradient
    ><linearGradient id="f" x1="52.917%" x2="51.315%" y1="91.144%" y2="74.539%"
      ><stop offset="10%" stop-color="#02131F" /><stop
        offset="90%"
        stop-color="#02131F"
        stop-opacity="0"
      /></linearGradient
    ><linearGradient id="g" x1="100.407%" x2="83.333%" y1="42.264%" y2="45.063%"
      ><stop offset="20%" stop-color="#02131F" /><stop
        offset="90%"
        stop-color="#02131F"
        stop-opacity="0"
      /></linearGradient
    ><linearGradient id="h" x1="53.165%" x2="50.633%" y1="54.992%" y2="51.331%"
      ><stop offset="0%" stop-color="#02131F" /><stop
        offset="10%"
        stop-color="#02131F"
      /><stop
        offset="100%"
        stop-color="#02131F"
        stop-opacity="0"
      /></linearGradient
    ><linearGradient id="i" x1="50.819%" x2="48.756%" y1="48.512%" y2="49.95%"
      ><stop offset="30%" stop-color="#02131F" /><stop
        offset="30%"
        stop-color="#02131F"
      /><stop
        offset="80%"
        stop-color="#02131F"
        stop-opacity="0"
      /></linearGradient
    ><linearGradient id="j" x1="50.88%" x2="49.484%" y1="48.153%" y2="49.231%"
      ><stop offset="40%" stop-color="#27343C" /><stop
        offset="100%"
        stop-color="#3B474E"
        stop-opacity="0"
      /></linearGradient
    ><linearGradient id="k" x1="33.18%" x2="71.489%" y1="32.01%" y2="71.96%"
      ><stop offset="0%" stop-color="#24303A" stop-opacity="0" /><stop
        offset="0%"
        stop-color="#25323B"
        stop-opacity="0"
      /><stop offset="10%" stop-color="#27343C" /></linearGradient
    ><linearGradient id="l" x1="55%" x2="55%" y1="102.109%" y2=".874%"
      ><stop offset="30%" stop-color="#A5ABAF" /><stop
        offset="100%"
        stop-color="#A5ABAF"
        stop-opacity="0"
      /></linearGradient
    ><linearGradient id="m" x1="50.16%" x2="50.16%" y1="0%" y2="100%"
      ><stop offset="0%" stop-color="#DEE0DD" /><stop
        offset="0%"
        stop-color="#C5C9C7"
      /><stop offset="0%" stop-color="#9EA4A5" /><stop
        offset="0%"
        stop-color="#82898C"
      /><stop offset="0%" stop-color="#71797D" /><stop
        offset="0%"
        stop-color="#6B7378"
      /><stop offset="20%" stop-color="#333F47" /><stop
        offset="50%"
        stop-color="#27343C"
      /><stop offset="80%" stop-color="#333F47" /><stop
        offset="100%"
        stop-color="#434D54"
      /></linearGradient
    ><linearGradient id="n" x1="45%" x2="45%" y1="50%" y2="50%"
      ><stop offset="0%" stop-color="#DEE0DD" /><stop
        offset="0%"
        stop-color="#C5C9C7"
      /><stop offset="0%" stop-color="#9EA4A5" /><stop
        offset="0%"
        stop-color="#82898C"
      /><stop offset="0%" stop-color="#71797D" /><stop
        offset="0%"
        stop-color="#6B7378"
      /><stop offset="20%" stop-color="#333F47" /><stop
        offset="50%"
        stop-color="#27343C"
      /><stop offset="80%" stop-color="#333F47" /><stop
        offset="100%"
        stop-color="#434D54"
      /></linearGradient
    ><linearGradient id="o" x1="64.364%" x2="43.066%" y1="12.225%" y2="60.636%"
      ><stop offset="70%" stop-color="#27343C" /><stop
        offset="70%"
        stop-color="#2B373F"
      /><stop offset="70%" stop-color="#36424A" /><stop
        offset="70%"
        stop-color="#49545B"
      /><stop offset="80%" stop-color="#646D73" stop-opacity="0" /><stop
        offset="80%"
        stop-color="#868D92"
        stop-opacity="0"
      /><stop offset="80%" stop-color="#B0B5B8" stop-opacity="0" /><stop
        offset="80%"
        stop-color="#E1E3E4"
        stop-opacity="0"
      /><stop offset="80%" stop-color="#FFF" stop-opacity="0" /></linearGradient
    ></defs
  ><g fill="none"
    ><path
      fill="url(#a)"
      d="M63.3,32 C63.3,49.3 49.3,63.3 32,63.3 C14.7,63.3 0.7,49.3 0.7,32 C0.7,14.7 14.7,0.7 32,0.7 C49.3,0.7 63.3,14.7 63.3,32 Z M32,2.6 C15.7,2.6 2.6,15.7 2.6,32 C2.6,48.3 15.8,61.4 32,61.4 C48.3,61.4 61.4,48.2 61.4,32 C61.4,15.7 48.3,2.6 32,2.6 Z"
    /><path
      fill="url(#b)"
      d="M32,2.6 C15.7,2.6 2.6,15.7 2.6,32 C2.6,48.3 15.8,61.4 32,61.4 C48.3,61.4 61.4,48.2 61.4,32 C61.4,15.7 48.3,2.6 32,2.6 Z M32,59.5 C16.8,59.5 4.5,47.2 4.5,32 C4.5,16.8 16.8,4.5 32,4.5 C47.2,4.5 59.5,16.8 59.5,32 C59.5,47.2 47.2,59.5 32,59.5 Z"
    /><path
      fill="url(#c)"
      d="M32,63.3 C49.3,63.3 63.3,49.3 63.3,32 C63.3,14.7 49.3,0.7 32,0.7 C14.7,0.7 0.7,14.7 0.7,32 C0.7,49.3 14.7,63.3 32,63.3 L32,63.3 Z M32,0 C49.6,0 64,14.4 64,32 C64,49.6 49.6,64 32,64 C14.4,64 0,49.6 0,32 C0,14.4 14.4,0 32,0 L32,0 Z"
      opacity=".4"
    /><path
      fill="#FFF"
      d="M2.2,32.1 C2.2,15.7 15.5,2.2 32,2.2 L32,2.2 C48.5,2.2 61.8,15.6 61.8,32.1 L61.8,32.1 C61.8,48.5 48.5,61.8 32,61.8 L32,61.8 C15.5,61.8 2.2,48.5 2.2,32.1 L2.2,32.1 Z M11.5,11.5 C6.2,16.8 2.9,24.1 2.9,32.1 L2.9,32.1 C2.9,40.1 6.2,47.4 11.4,52.6 L11.4,52.6 C16.7,57.8 24,61.1 32,61.1 L32,61.1 C40,61.1 47.3,57.9 52.5,52.6 L52.5,52.6 C57.8,47.4 61,40.1 61,32.1 L61,32.1 C61,24.1 57.7,16.8 52.5,11.5 L52.5,11.5 C47.3,6.2 40,2.9 32,2.9 L32,2.9 C24,2.9 16.7,6.2 11.5,11.5 L11.5,11.5 Z"
    /><path
      fill="url(#d)"
      d="M32,59.6 C24.6,59.6 17.7,56.7 12.5,51.5 C7.3,46.3 4.4,39.4 4.4,32 C4.4,24.6 7.3,17.7 12.5,12.5 C17.7,7.3 24.6,4.4 32,4.4 C39.4,4.4 46.3,7.3 51.5,12.5 C56.7,17.7 59.6,24.6 59.6,32 C59.6,39.4 56.7,46.3 51.5,51.5 C46.3,56.7 39.4,59.6 32,59.6 L32,59.6 Z M32,58.8 C39.1,58.8 45.9,56 50.9,51 C56,45.9 58.7,39.2 58.7,32.1 C58.7,25 55.9,18.2 50.9,13.2 C45.8,8.1 39.1,5.4 32,5.4 C24.9,5.4 18.1,8.2 13.1,13.2 C8,18.1 5.2,24.9 5.2,32 C5.2,39.1 8,45.9 13,50.9 C18.1,56 24.9,58.8 32,58.8 L32,58.8 Z"
      opacity=".4"
    /><path
      fill="#FFF"
      d="M56.3,45 C55.8,44.6 36.5,29.3 36.5,29.3 L32,3.6 C31.7,3.7 31.3,4 31.1,4.4 L27.9,29.4 L8,44.7 C8,44.7 7.6,45.2 7.4,45.5 C7.3,45.7 7.3,46 7.3,46.3 C7.3,46.3 7.3,46.3 7.3,46.3 L31.9,36.2 L56.5,46.3 C56.5,46.3 56.5,46.3 56.5,46.3 C56.7,45.8 56.5,45.3 56.3,45 Z"
    /><path
      fill="#565F64"
      d="M32.2,32.8 L32,37.4 L54.6,46.5 C55.4,46.9 56,46.7 56.6,46.3 L32.5,32.7 C32.4,32.6 32.2,32.7 32.2,32.8 Z"
    /><path
      fill="url(#e)"
      d="M32.2,32.8 C32.2,32.8 33.5,35.1 35,36.7 C37.1,39 39.9,40.6 39.9,40.6 L54.6,46.5 C55.4,46.9 56,46.7 56.6,46.3 L32.5,32.7 C32.4,32.6 32.2,32.7 32.2,32.8 Z"
    /><path
      fill="#A4AAAE"
      fill-opacity=".6"
      d="M56.5,45.4 C56.5,45.3 56.4,45.2 56.3,45 L35.7,29.9 L32.9,31.7 C32.9,31.7 33.1,31.8 33.2,31.7 C33.5,31.6 34.1,31.5 34.7,31.7 C35.2,31.9 56.5,45.5 56.5,45.5 C56.5,45.5 56.5,45.5 56.5,45.4 Z"
    /><path
      fill="#333E46"
      d="M55.8,44.5 L36.6,29.3 L36.6,29.3 L35.7,29.9 L56.3,45.1 C56.2,44.9 56,44.7 55.8,44.5 Z"
    /><path
      fill="#565F64"
      d="M32.5,31.3 C32.4,31.4 32.4,31.4 32.4,31.4 C32.4,31.4 32.4,31.6 32.6,31.5 C32.7,31.4 35.6,29.9 36.6,29.3 L33.1,5.3 C33,4.4 32.6,4 31.9,3.7 L32.3,31.5 L32.5,31.3 Z"
    /><path
      fill="#A4AAAE"
      fill-opacity=".6"
      d="M30.8 5.3 30.8 6.6 28.6 28.7C28.6 29 28.7 29.3 29 29.5L30.3 30.5 31.2 6.1 31.3 4.2C31 4.4 30.9 4.8 30.8 5.3ZM29.6 30.9 28.4 29.9 8.1 44.6C8.1 44.6 7.5 45 7.4 45.4L7.4 45.4C7.4 45.4 7.4 45.4 7.4 45.4L7.4 45.4 8.1 45 8.1 45 29.4 31.6C29.8 31.4 29.9 31.2 29.6 30.9Z"
    /><path
      fill="#565F64"
      d="M31.7,32.8 C31.7,32.7 31.6,32.6 31.5,32.7 L7.3,46.4 C7.9,46.8 8.5,46.9 9.3,46.6 L31.9,37.5 L31.7,32.8 Z"
    /><path
      fill="url(#f)"
      d="M32.4,31.4 L32.5,31.3 C32.4,31.4 32.4,31.4 32.4,31.4 L32.4,31.4 C32.4,31.4 32.4,31.5 32.5,31.5 C32.5,31.5 32.6,31.5 32.6,31.5 C32.7,31.4 35.6,29.9 36.6,29.3 L36.2,26.4 L36.2,26.4 L33.1,5.3 C33.1,4.9 33,4.6 32.8,4.4 C32.8,4.4 34.3,24.6 34.3,26.8 C34.3,29.7 32.4,31.4 32.4,31.4 Z"
    /><path
      fill="url(#g)"
      fill-opacity=".8"
      d="M31.7,32.8 C31.7,32.7 31.6,32.6 31.5,32.7 L7.3,46.4 C7.9,46.8 8.5,46.9 9.3,46.6 L31.9,37.5 L31.7,32.8 Z"
    /><path
      fill="url(#h)"
      d="M9.3,46.5 L31.9,37.4 L31.7,33 C31.3,34.2 30.6,35.5 28.7,36.5 C28.7,36.5 28.7,36.5 28.7,36.5 C27.3,37.3 13.9,43.9 9.1,46.2 C8.8,46.4 8.4,46.5 8.2,46.6 C8.6,46.8 8.9,46.7 9.3,46.5 Z"
      opacity=".8"
    /><path
      fill="url(#i)"
      d="M32.5,31.3 C32.4,31.4 32.4,31.4 32.4,31.4 C32.4,31.4 32.4,31.6 32.6,31.5 C32.7,31.4 35.6,29.9 36.6,29.3 L33.1,5.3 C33,4.4 32.6,4 31.9,3.7 L32.3,31.5 L32.5,31.3 Z"
    /><path
      fill="url(#j)"
      d="M32.5,31.3 C32.4,31.4 32.4,31.4 32.4,31.4 C32.4,31.4 32.4,31.6 32.6,31.5 C32.7,31.4 35.6,29.9 36.6,29.3 L33.1,5.3 C33,4.4 32.6,4 31.9,3.7 L32.3,31.5 L32.5,31.3 Z"
    /><path
      fill="url(#k)"
      d="M5.1,44.4 C4.4,42.8 0.4,35 4.8,20 L3.1,20 C2.2,23 1.5,24.8 1.1,27.5 C1.1,27.5 0.9,28.5 0.8,29.6 C0.7,30.7 0.7,31.3 0.7,32 C0.7,38 2.2,41.5 2.2,41.5 C3.8,46.5 6.6,51 10.4,54.4 C13.7,57.3 18.8,59.5 23,60.3 C22.3,60.2 10.3,55.1 5.1,44.4 Z"
    /><path
      fill="url(#l)"
      d="M32.4,32.6 L31.5,32.6 L31.5,32.6 C31.6,32.6 31.7,32.6 31.7,32.7 L31.9,37.3 L31.9,37.3 L32,37.3 L32.2,32.7 C32.2,32.6 32.3,32.5 32.4,32.6 L32.4,32.6 L32.4,32.6 Z"
    /><path
      fill="url(#m)"
      d="M42,2.3 C52.5,6.3 62.4,17.3 62.4,31.2 C62.4,48 49,61.7 32,61.7 L32,63.3 C49,63.3 63.3,49.3 63.3,32 C63.3,18.2 54.5,6.6 42,2.3 Z"
    /><path
      fill="url(#n)"
      d="M32.3,0.7 C32.2,0.7 32.1,0.7 32,0.7 C32.1,0.7 32.2,0.7 32.3,0.7 C32.3,0.7 32.3,0.7 32.3,0.7 Z"
    /><path
      fill="url(#o)"
      d="M58.8,20.2 C51.8,4.1 36,3.2 35.1,3.1 C35.1,3.1 35.1,3.1 35,3.1 L35,3.1 C47.1,5.3 54.8,13.2 57.5,21.5 C57.5,21.5 57.5,21.6 57.5,21.6 C58.7,24.8 59.3,28.2 59.4,31.9 C59.5,35.4 58.7,39.3 57.2,42.9 C57.1,43.4 57,44 56.9,44 L58.5,44 C63.3,35 61.2,25.9 58.8,20.2 Z"
    /><path
      fill="#FBFBFB"
      d="M2.2,32.1 C2.2,15.7 15.5,2.2 32,2.2 L32,2.2 C48.5,2.2 61.8,15.6 61.8,32.1 L61.8,32.1 C61.8,48.5 48.5,61.8 32,61.8 L32,61.8 C15.5,61.8 2.2,48.5 2.2,32.1 L2.2,32.1 Z M11.5,11.5 C6.2,16.8 2.9,24.1 2.9,32.1 L2.9,32.1 C2.9,40.1 6.2,47.4 11.4,52.6 L11.4,52.6 C16.7,57.8 24,61.1 32,61.1 L32,61.1 C40,61.1 47.3,57.9 52.5,52.6 L52.5,52.6 C57.8,47.4 61,40.1 61,32.1 L61,32.1 C61,24.1 57.7,16.8 52.5,11.5 L52.5,11.5 C47.3,6.2 40,2.9 32,2.9 L32,2.9 C24,2.9 16.7,6.2 11.5,11.5 L11.5,11.5 Z"
    /><path
      fill="#333F47"
      d="M7.9,44.8 L7.9,44.8 L28.3,30.1 C29.4,30.7 31.2,31.5 31.4,31.5 C31.6,31.6 31.6,31.4 31.6,31.4 L29.1,29.3 C28.8,29.1 28.7,28.8 28.7,28.5 L31.1,4.4 C31,4.5 31,4.7 30.9,4.8 C30.8,5 30.8,5.1 30.8,5.3 L27.3,29.4 L8.1,44.5 C8,44.6 7.9,44.7 7.9,44.8 Z"
    /></g
  ></svg
>
